export default function (config, options) {
  console.log('client.ts', { config, options });
}
